import { useRef, useEffect } from 'react';
import first from 'lodash/fp/first';
import flow from 'lodash/fp/flow';
import get from 'lodash/fp/get';

export default function useResizeObserver({
	onResize = () => {
		//void
	},
}) {
	const elementForResizeObserver = useRef(null);

	useEffect(() => {
		const handleResize = entries =>
			flow(Array.from, first, get(['contentBoxSize', 0]), onResize)(entries);

		const resizeObserver = new ResizeObserver(handleResize);

		const el = elementForResizeObserver.current;
		if (!el) {
			return;
		}
		resizeObserver.observe(el);

		return () => {
			resizeObserver.unobserve(el);
		};
	}, []);

	return {
		element: elementForResizeObserver,
	};
}
